<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-th-large"></i><span> Seguros</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('seguro.crear')" >
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                            </template>

                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getlistSeguros(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>

                               <div class="col-md-6 col-sm-12">
                                    <div>
                                        <el-input @keyup.enter.native="getlistSeguros(1,pag_mostrar)" placeholder="Texto a buscar" v-model="cBusqueda" class="input-with-select" clearable>
                                            <el-select v-model="cCriterio" slot="prepend" placeholder="Select">
                                            <el-option value="nombre" label="Nombre "></el-option>
                                            </el-select> <i class="fas fa-search"></i>
                                            <el-button class="button-library-group" slot="append" icon="fas fa-search" @click.prevent="getlistSeguros(1,pag_mostrar)"></el-button>
                                        </el-input>
                                    </div>
                                </div>

                            </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Logo</b></th>
                                            <th><b>Nombre</b></th>
                                            <th><b>Auto * Auto</b></th>
                                            <th><b>Cero Deducible</b></th>
                                            <th><b>Amparo Patrimonial</b></th>
                                            <th><b>Desgravamen</b></th>
                                            <th><b>Dispositivo de Rastreo</b></th>
                                            <th><b>Correo</b></th>
                                            <th><b>Estado</b></th>
                                            <th><b>Acciones</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listSeguro.length">
                                        <tr v-for="(c, index) in listSeguro" :key="index">

                                            <td  class="center-img">
                                                <template v-if="!c.logo">
                                                    <img src="img/no-image.png" :alt="c.logo" class="img-table">
                                                </template>
                                                <template v-else>
                                                    <img v-bind:src="'storage/seguro/'+c.logo" class="img-table" :alt="c.logo">
                                                </template>

                                            </td>
                                            <td v-text="c.nombre"></td>
                                            <td v-text="c.auto_auto"></td>
                                            <td v-text="c.cero_deducible"></td>
                                            <td v-text="c.amparo_patrimonial"></td>
                                            <td v-text="c.desgravamen"></td>
                                            <td v-text="c.dispositivo_rastreo"></td>
                                            <td v-text="c.correo"></td>
                                            <td>
                                                <span class="u-label bg-success text-white" v-if="c.state=='A'" >Activo</span>
                                                <span class="u-label bg-danger text-white" v-else>Desactivado</span>
                                            </td>
                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">

                                                       <template v-if="AsignarRolPermisosByUsuario.includes('seguro.eliminar')" >
                                                            <button class="dropdown-item" v-if="c.state=='I'"  @click="setDeleteSeguro(c.id,c.logo)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>
                                                        </template>
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('seguro.ver')" >
                                                            <button class="dropdown-item" @click="abrirModalTasas(c.id)"><i class="far fa-eye" ></i> Ver</button>
                                                        </template>
                                                       <template v-if=" AsignarRolPermisosByUsuario.includes('seguro.desactivar')">
                                                            <button class="dropdown-item" v-if="c.state=='A'"   @click="setEstadoSeguro(1,c.id)"><i class="fas fa-trash text-danger" ></i> Desactivar</button>
                                                        </template>
                                                        <template v-if=" AsignarRolPermisosByUsuario.includes('seguro.activar')">
                                                            <button class="dropdown-item" v-if="c.state=='I'" @click="setEstadoSeguro(2,c.id)" ><i class="fas fa-check text-success" ></i>  Activar</button>
                                                        </template>

                                                         <template v-if="AsignarRolPermisosByUsuario.includes('seguro.editar')">
                                                            <button class="dropdown-item" @click="setObtenerSeguro(c.id)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        </template>

                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="10" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal -------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"> </h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="shortcode-html">
                             <form id="for-seguros">
                                <div class="row"  style="padding-top:10px">

                                    <div class="col-md-4">
                                            <div class="col-md-12 col-sm-12 col-lg-12">
                                                <div class="form-group" align="center">
                                                    <label>Logo de la Empresa</label>
                                                    <input vue-load-image type="file" @change="obtenerImagen"  class="form-control btn btn-sm btn-primary" id="imgSeguro" accept="image/*"
                                                    >
                                                </div>
                                            </div>
                                    </div>

                                    <div class="col-md-8">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <div class="form-group">
                                                    <label>Nombre del Seguro</label>
                                                    <input type="text" class="form-control" id="name" v-model="vaCreSeguro.nombre" placeholder="Ingresar Nombre de la Empresa">
                                                </div>
                                            </div>

                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <div class="form-group">
                                                    <label>$  Auto x Auto</label>
                                                    <money v-model="vaCreSeguro.adicional" v-bind="money"  class="form-control"></money>
                                                </div>
                                            </div>

                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <div class="form-group">
                                                    <label>% Cero Deducible</label>
                                                    <el-input-number v-model="vaCreSeguro.deducible" :precision="2" :step="0.1" :max="100"></el-input-number>
                                                </div>
                                            </div>

                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <div class="form-group">
                                                    <label>% Amparo Patrimonial</label>
                                                    <el-input-number v-model="vaCreSeguro.patrimonial" :precision="2" :step="0.1" :max="100"></el-input-number>
                                                </div>
                                            </div>

                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <div class="form-group">
                                                    <label>% Desgravamen</label>
                                                    <el-input-number v-model="vaCreSeguro.concesionario" :precision="2" :step="0.1" :max="100"></el-input-number>
                                                </div>
                                            </div>

                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <div class="form-group">
                                                    <label>$ Dispositivo de rastreo</label>
                                                    <money v-model="vaCreSeguro.dispositivo_rastreo" v-bind="money"  class="form-control"></money>
                                                </div>
                                            </div>

                                            <div class="col-md-12 col-sm-12 col-lg-12">
                                                <div class="form-group">
                                                    <label>Correo</label>
                                                    <input type="text" class="form-control" id="name" v-model="vaCreSeguro.correo" placeholder="Ingresar correo  de la Empresa">
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="col-md-12 border">
                                            <br>


                                            <div  class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr align="center" class="table-primary">
                                                            <th >Coberturas</th>
                                                            <th colspan="3">
                                                                <button class="btn btn-primary" @click="seleccionarTodoCoberturas()" type="button">
                                                                    <i :class="(selectDeselectAllCober == true) ? 'far fa-check-square fa-lg': 'far fa-square fa-lg'"></i>
                                                                    Seleccionar todo
                                                                </button>
                                                            </th>
                                                        </tr>
                                                        <tr align="center">
                                                            <th>Nombre</th>
                                                            <th>Aplica</th>
                                                            <th>Tipo</th>
                                                            <th>Descripción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="arrayCobertura.length">
                                                        <tr v-for="(c, index) in arrayCobertura" :key="index">
                                                            <td v-text="c.nombre"></td>
                                                            <td>
                                                                <template align="center">
                                                                    <div class="center">
                                                                    <vs-checkbox v-model="c.aplica" @click="selectDeselectAllCober=false">
                                                                            {{((c.aplica==true) ? 'SI': 'NO')}}
                                                                    </vs-checkbox>
                                                                    </div>
                                                                </template>
                                                            </td>
                                                            <td v-text="c.tipo_variable" align="center"></td>
                                                            <td>
                                                                <input v-if="c.tipo_variable=='TEXTO'" type="text" class="form-control" v-model="c.descripcion" placeholder="Ingresar Descripción">
                                                                <el-input-number v-else-if="c.tipo_variable =='PORCENTAJE'" v-model="c.monto" :precision="2" :step="0.1" :max="100"></el-input-number>
                                                                <money v-else v-model="c.monto" v-bind="money"  class="form-control"></money>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-else>
                                                        <td colspan="4" align="center">
                                                            <h5>No se encontraron resultados...</h5>
                                                        </td>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div  class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr align="center" class="table-primary">
                                                            <th >Deducibles</th>
                                                            <th colspan="3">
                                                                <button class="btn btn-primary" @click="seleccionarTodoDedudcibles()" type="button">
                                                                    <i :class="(selectDeselectAllDedu == true) ? 'far fa-check-square fa-lg': 'far fa-square fa-lg'"></i>
                                                                    Seleccionar todo
                                                                </button>
                                                            </th>
                                                        </tr>
                                                        <tr align="center">
                                                            <th>Nombre</th>
                                                            <th>Aplica</th>
                                                            <th>Tipo</th>
                                                            <th>Descripción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="arrayDeducible.length">
                                                        <tr v-for="(c, index) in arrayDeducible" :key="index">
                                                            <td v-text="c.nombre"></td>
                                                            <td>
                                                                <template align="center">
                                                                    <div class="center">
                                                                    <vs-checkbox v-model="c.aplica"  @click="selectDeselectAllDedu=false">
                                                                            {{((c.aplica==true) ? 'SI': 'NO')}}
                                                                    </vs-checkbox>
                                                                    </div>
                                                                </template>
                                                            </td>
                                                            <td v-text="c.tipo_variable" align="center"></td>
                                                            <td>
                                                                <input v-if="c.tipo_variable=='TEXTO'" type="text" class="form-control" v-model="c.descripcion" placeholder="Ingresar Descripción">
                                                                <el-input-number v-else-if="c.tipo_variable =='PORCENTAJE'" v-model="c.monto" :precision="2" :step="0.1" :max="100"></el-input-number>
                                                                <money v-else v-model="c.monto" v-bind="money"  class="form-control"></money>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-else>
                                                        <td colspan="4" align="center">
                                                            <h5>No se encontraron resultados...</h5>
                                                        </td>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary" @click="setRegistrarSeguro()" v-text="nameButon"></button>
                            <button type="button" v-if="actu_reg==1" class="btn btn-sm btn-primary" @click="setActualizarSeguro" v-text="nameButon"></button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal -------------------------------------------------------------->

        <!--   Inicio modal -------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow2 }" :style=" modalShow2 ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"> </h5>
                        <button type="button" @click="cerrarModalTasas" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div  class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr align="center">
                                        <th>% Tasa de Interes</th>
                                     </tr>
                                </thead>
                                <tbody v-if="arrayTasas.length">
                                    <tr v-for="(c, index) in arrayTasas" :key="index">
                                        <td v-text="c.tasa + ' %'"></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <td colspan="1" align="center">
                                        <h5>No se encontraron resultados...</h5>
                                    </td>
                                </tbody>
                            </table>
                        </div>
                    </div>

                     <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-secondary" @click="cerrarModalTasas">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal -------------------------------------------------------------->

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {
    props: ['ruta'],
    data() {
        return {
            cCriterio: 'nombre',
            cBusqueda: '',
            listSeguro: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
             vaCreSeguro:{
                eId: 0,
                adicional: 0.0,
                deducible : 0.0,
                patrimonial : 0.0,
                concesionario : 0.0,
                dispositivo_rastreo : 0.0,
                nombre: '',
                logo: '',
                correo: '',

            },
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
            },
            tasa: 0.0,
            form: new FormData,
            arrayTasas: [],
            modalShow2 : false,
            arrayCobertura: [],
            arrayDeducible: [],
            arrayDefinitivo: [],
            selectDeselectAllCober: false,
            selectDeselectAllDedu: false,



        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
    methods: {


        getlistSeguros(page,pag_mostrar){

          var url = '/seguro';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.post(url,{

                  'cCriterio': this.cCriterio,
                  'cBusqueda': this.cBusqueda,
                  'page' : page,
                  'pag_mostrar': pag_mostrar

          })
          .then(res => {
                var respuesta = res.data;
                this.listSeguro = respuesta.seguro.data;
                this.pagination = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
               // console.log(res.data);
          })
          .catch(err => {
              console.error(err);
              this.openCargando(true);
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }

          })

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getlistSeguros(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.openCargando();//Activamos ventana de carga de bloqueo


                this.tituloModal = "Registrar Seguro";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

                var url = '/seguro/list'

                axios.get(url)
                .then(res => {


                    var arrayCobertura1 = [];
                    res.data.cobertura.map(function(value, key) {
                        //list.push(value);
                        arrayCobertura1.push({
                            id: value.id,
                            nombre: value.nombre,
                            aplica: ((value.aplica=='SI') ? true : false),
                            monto: 0,
                            descripcion: '',
                            tipo_variable : value.tipo_variable
                        });

                    });

                    this.arrayCobertura = arrayCobertura1;

                    var arrayDeducible1 = [];
                    res.data.deducible.map(function(value, key) {
                        //list.push(value);
                        arrayDeducible1.push({
                            id: value.id,
                            nombre: value.nombre,
                            aplica: ((value.aplica=='SI') ? true : false),
                            monto: 0,
                            descripcion: '',
                            tipo_variable : value.tipo_variable
                        });

                    });
                     this.arrayDeducible = arrayDeducible1;



                     this.arrayDefinitivo = this.arrayCobertura.concat(this.arrayDeducible);
                     this.openCargando(true);//Activamos ventana de carga de bloqueo
                })
                .catch(err => {
                   console.error(err);
                    this.openCargando(true);//Activamos ventana de carga de bloqueo
                    if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                        }
                })

            }else{
               // this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },

        cleanVariables(){
           // $("#for-seguros")[0].reset();
            this.vaCreSeguro.nombre  = "";
             this.vaCreSeguro.correo  = "";
            this.vaCreSeguro.eId  = 0;
             this.vaCreSeguro.adicional  = 0.0;
            this.vaCreSeguro.deducible  = 0.0;
            this.vaCreSeguro.patrimonial  = 0.0;
            this.vaCreSeguro.concesionario  = 0.0;
            this.vaCreSeguro.dispositivo_rastreo  = 0.0;
            this.vaCreSeguro.logo  = "";

            this.arrayCobertura = [];
            this.arrayDeducible = [];
             this.arrayDefinitivo = [];
            this.form =  new FormData;
            $('#imgSeguro').fileinput('clear');
        },

        setRegistrarSeguro(){
            this.openCargando();


           // this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/seguro/registrar';
            this.form = new FormData;
            this.form.append('nombre', this.vaCreSeguro.nombre);
            this.form.append('adicional', this.vaCreSeguro.adicional);
            this.form.append('deducible', this.vaCreSeguro.deducible);
            this.form.append('patrimonial', this.vaCreSeguro.patrimonial);
            this.form.append('concesionario', this.vaCreSeguro.concesionario);
            this.form.append('dispositivo_rastreo', this.vaCreSeguro.dispositivo_rastreo);
            this.form.append('logo', this.vaCreSeguro.logo);
            this.form.append('correo', this.vaCreSeguro.correo);


            this.form.append('cobertura_deducible',JSON.stringify(this.arrayDefinitivo));

            const config = { headers: { 'Content-Type': 'multipart/form-data'}}//Aceptamos archivos

            axios.post(url, this.form, config).then(res => {
                //console.log(res.data);
            this.openCargando(true);

                if(res.data.status){

                    this.cleanVariables();//Limpiamos el form
                    this.getlistSeguros(1,this.pag_mostrar);
                    this.modalShow=false;

                    this.notify(" Seguro registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }else{
                    this.notify(" Error al registrar el seguro","","top","center","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
                if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
            })
        },


        setActualizarSeguro(){
             this.openCargando();


           // this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/seguro/actualizar';
            this.form = new FormData;
            this.form.append('id', this.vaCreSeguro.eId);
            this.form.append('nombre', this.vaCreSeguro.nombre);
            this.form.append('adicional', this.vaCreSeguro.adicional);
            this.form.append('deducible', this.vaCreSeguro.deducible);
            this.form.append('patrimonial', this.vaCreSeguro.patrimonial);
            this.form.append('concesionario', this.vaCreSeguro.concesionario);
            this.form.append('dispositivo_rastreo', this.vaCreSeguro.dispositivo_rastreo);
            this.form.append('logo', this.vaCreSeguro.logo);
            this.form.append('correo', this.vaCreSeguro.correo);

            this.form.append('cobertura_deducible',JSON.stringify(this.arrayDefinitivo));

            const config = { headers: { 'Content-Type': 'multipart/form-data'}}//Aceptamos archivos

            axios.post(url, this.form, config).then(res => {
               this.openCargando(true);


                if(res.data.status){

                    this.cleanVariables();//Limpiamos el form
                    this.getlistSeguros(1,this.pag_mostrar);
                    this.modalShow=false;

                    this.notify(" Seguro actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }else{
                    this.notify(" Error al actualizar el seguro","","top","center","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
                if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
            })
        },

        abrirModalTasas(id){

           this.openCargando();//Activamos ventana de carga de bloqueo
           var url = '/seguro/tasas'

           axios.post(url,{'id':id})
           .then(res => {

               this.arrayTasas = res.data.tasas;
               this.openCargando(true);//Activamos ventana de carga de bloqueo
               this.tituloModal = "Tasas Pertenecientes al Seguro";
               this.modalShow2 = true;
           })
           .catch(err => {

               console.error(err);
               this.openCargando(true);//Activamos ventana de carga de bloqueo
               if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
           })
        },

        cerrarModalTasas(){
            this.modalShow2 = !this.modalShow2;
            this.arrayTasas=[];
        },

         //Actualizamos el estado de la categoria
        setEstadoSeguro(op, id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de ' + ((op == 1) ? 'desactivar' : 'activar') + ' el seguro?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: ((op == 1) ? 'Si, desactivar' : 'Si, activar'),
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){

                        var url = '/seguro/estado';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                            'estado' : (op == 1) ? 'I' : 'A'
                        })
                        .then(res => {

                            if(res.data.status){
                             this.notify(' Se ' + ((op == 1) ? 'desactivo' : 'activo') + ' el seguro',"","top","center",((op == 1) ? 'fas fa-check-circle' : 'fas fa-check-circle'),'success',' flipInX','flipOutX')
                            }
                            this.getlistSeguros(1,this.pag_mostrar);
                        })
                        .catch(err => {
                            console.error(err);
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                    if (localStorage['authUser']) {
                                        this.$router.push({name: 'login'})
                                        location.reload();
                                        localStorage.clear();
                                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                    }
                                }
                        })
                }
            })
        },

        setDeleteSeguro(id,img){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el Seguro?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){
                        var url = '/seguro/delete';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                            'img': img
                        })
                        .then(res => {


                             this.openCargando(true);

                            if(res.data.status){
                                this.notify(" Seguro Eliminado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                            }else{
                                this.notify(" El Seguro no se puede eliminar por que está en uso","","top","center","fas fa-exclamation-triangle","warning",' flipInX','flipOutX')
                            }
                            this.getlistSeguros(1,this.pag_mostrar);
                        })
                        .catch(err => {
                            console.error(err);
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                            }
                        })
                }
            })
        },

        //Obtenemos los datos al seleccionar una imagen
        obtenerImagen(e){
            let file =  e.target.files[0]
            this.vaCreSeguro.logo = file
        },

        setObtenerSeguro(id){
            var me = this;
            var url = '/seguro/obtener';
            me.openCargando();//Activamos ventana de carga de bloqueo
            axios.post(url,{'id':id})
            .then(res => {

                me.tituloModal = "Actualizar Seguro";
                me.actu_reg = 1;
                me.nameButon = "Actualizar";

                var scd  = res.data.scd;

                     for (let index2 = 0; index2 < scd.length; index2++) {

                         if( scd[index2].tipo == 'COBERTURA' ){

                             me.arrayCobertura.push({
                                id: scd[index2].id,
                                nombre: scd[index2].nombre,
                                aplica: ((scd[index2].aplica=='SI') ? true : false),
                                monto: scd[index2].monto,
                                descripcion: scd[index2].descripcion,
                                tipo_variable : scd[index2].tipo_variable,
                            });

                         }

                         if( scd[index2].tipo == 'DEDUCIBLE' ){

                             me.arrayDeducible.push({
                                id: scd[index2].id,
                                nombre: scd[index2].nombre,
                                aplica: ((scd[index2].aplica=='SI') ? true : false),
                                monto: scd[index2].monto,
                                descripcion: scd[index2].descripcion,
                                tipo_variable : scd[index2].tipo_variable,
                            });

                         }
                     }




                me.arrayDefinitivo = me.arrayCobertura.concat(me.arrayDeducible);
                var seguro = res.data.seguro[0];
                this.vaCreSeguro.nombre  = seguro.nombre;
                this.vaCreSeguro.eId  = seguro.id;
                this.vaCreSeguro.adicional  = seguro.auto_auto;
                this.vaCreSeguro.deducible  =  seguro.cero_deducible;
                this.vaCreSeguro.patrimonial  =  seguro.amparo_patrimonial;
                this.vaCreSeguro.concesionario  =  seguro.desgravamen;
                this.vaCreSeguro.dispositivo_rastreo  =  seguro.dispositivo_rastreo;
                this.vaCreSeguro.logo  =  seguro.logo;
                this.vaCreSeguro.correo = seguro.correo;
                 if(this.vaCreSeguro.logo)
                    {
                        document.getElementById("img-seguro").src = "storage/seguro/"+ this.vaCreSeguro.logo;
                    }



                me.modalShow = true;
                me.openCargando(true);//Activamos ventana de carga de bloqueo
                //console.log(res.data.cobertura)

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Activamos ventana de carga de bloqueo
                if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                }
            })

        },

        seleccionarTodoCoberturas(){
            for (let index = 0; index < this.arrayCobertura.length; index++) {
                this.arrayCobertura[index].aplica = !this.selectDeselectAllCober;
            }
            this.selectDeselectAllCober =!this.selectDeselectAllCober;
        },

         seleccionarTodoDedudcibles(){
            for (let index = 0; index < this.arrayDeducible.length; index++) {
                this.arrayDeducible[index].aplica = !this.selectDeselectAllDedu;
            }
            this.selectDeselectAllDedu =!this.selectDeselectAllDedu;
        },

    },
    mounted() {

            this.getlistSeguros(1,this.pag_mostrar);
            $(document).ready(function(){

            $('#imgSeguro').fileinput({
                    language: 'es',
                    allowedFileExtensions:['jpeg','jpg','png'],
                    maxFileSize: 8000,//8mb
                    showUpload:false,
                    showClose: false,
                    dropZoneEnabled: false,
                    browseLabel: '',
                    removeLabel: '',
                    browseIcon: '<i class="fas fa-folder-open"></i>',
                    removeIcon: '<i class="fas fa-trash-alt"></i>',
                    overwriteInitial: true,showCaption: false,
                    theme: "fa",
                    defaultPreviewContent:'<img id="img-seguro" class="center img-thumbnail" src="img/no-image.png">',
                });


        });


        },
}
</script>

<style>
</style>
